// @ts-strict-ignore
import { useState, useEffect } from 'react'
import { Image, ImageSourcePropType } from 'react-native'
import { isWeb } from 'APP/Helpers/checkPlatform'

const getSize = (source: ImageSourcePropType): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    if (isWeb()) {
      Image.getSize(
        source.toString(),
        (width = 0, height = 0) => resolve({ width, height }),
        reject
      )
    } else {
      resolve(Image.resolveAssetSource(source))
    }
  })
}

export default function useImageDimensions(source: ImageSourcePropType) {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchImageSize = async () => {
      setIsLoading(true)

      try {
        const size = await getSize(source)

        setDimensions(size)
      } catch (err) {
        setError(err)
      } finally {
        setIsLoading(false)
      }
    }

    if (source) {
      fetchImageSize()
    }
  }, [source])

  const aspectRatio =
    dimensions.width && dimensions.height ? dimensions.width / dimensions.height : 0

  return {
    width: dimensions.width,
    height: dimensions.height,
    aspectRatio,
    isLoading,
    error,
  }
}
